import { getJSON } from 'common/util/request'

export const getEditPropertiesModal = (documentId = '', committeeId) => {
    const result = getJSON(`committees/${committeeId}/minutes_documents/${documentId}/edit`)

    return result
}
